export default __webpack_public_path__ + "static/media/stylus.c2d07267.svg";